module.exports = __webpack_public_path__ + "media/veracruz/ActividadEcocultural-6709aa38.jpeg";